import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class CalcsScenarioDataSetupService {

  constructor(private http: HttpClient) { }

  // Get tax years - matches AngularJS TAX_YEARS constant behavior
  getTaxYears(baseUrl: string): Observable<any> {
    const url = `${baseUrl}/getTaxYears`;
    return this.http.get<any>(url);
  }

  // Get from scenario - matches AngularJS getFromScenario
  getFromScenario(baseUrl: string, params: any): Observable<any> {
    const jcd_key = params.jcd_key || '250';
    const scenario = params.scenario || '';
    const tax_year = params.tax_year || '';
    
    const url = `${baseUrl}/loadJsonObject?action_code=7q0wiy&jcd_key=${jcd_key}&scenario=${scenario}&tax_year=${tax_year}`;
    
    return this.http.get<any>(url);
  }

  // Get from filing group - matches AngularJS getFromFilingGroup (commented out in original)
  getFromFilingGroup(baseUrl: string, params: any): Observable<any> {
    const jcd_key = params.jcd_key || '250';
    const scenario = params.scenario || '';
    const tax_year = params.tax_year || '';
    
    const url = `${baseUrl}/loadJsonObject?action_id=762&jcd_key=${jcd_key}&scenario=${scenario}&tax_year=${tax_year}`;
    
    return this.http.get<any>(url);
  }

  // Save copy changes - matches AngularJS saveCopyChanges
  saveCopyChanges(baseUrl: string, params: any): Observable<any> {
    const tax_year = params.tax_year || '';
    const scenario = params.scenario || '';
    const jcd_key = params.jcd_key || '250';
    
    const url = `${baseUrl}/saveJsonObject?action_code=0betp4&tax_year=${tax_year}&scenario=${scenario}&jcd_key=${jcd_key}`;
    
    // Build URLSearchParams for POST data (matching AngularJS behavior)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== null && params[key] !== undefined) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }
}

